import { Outlet } from 'react-router-dom';

const BlankLayout = () => {
  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      <Outlet />
    </div>
  );
};

export default BlankLayout;